export default "__VITE_ASSET__VONYxAIc__"